import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateFormateService {
  formatDate(dateString: string): string {
    if (!dateString) return ''; 
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; 
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;

    const formattedDate = `${this.padZero(date.getMonth() + 1)}-${this.padZero(date.getDate())}-${date.getFullYear()} ${formattedHours}:${formattedMinutes} ${ampm}`;

    return formattedDate;
}

private padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
}


}
